// local imports
import 'pages/Tracing.scss'
import TracingSearchForm from './SearchForm'
import useCampusServiceTracing from './hooks/use-campus-service-tracing'
import TracingTable from './TracingTable'

export default function CampusServiceTracing() {
  const {
    selectedLocation,
    setSelectedLocation,
    selectedService,
    setSelectedService,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    fetchTableList,
    data,
    loading,
  } = useCampusServiceTracing()

  return (
    <div className="mb-4">
      {/* Filter Form */}
      <TracingSearchForm
        selectedService={selectedService}
        setSelectedService={setSelectedService}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        getTableList={fetchTableList}
      />

      <TracingTable
        data={data}
        selectedService={selectedService}
        getTableData={fetchTableList}
        endDate={endDate}
        loading={loading}
        startDate={startDate}
      />
    </div>
  )
}
